<template>
  <v-tabs v-if="hasId" v-model="activeTab" bg-color="grey-lighten-4">
    <v-tab :to="formRoute" value="form">
      {{ i18n.global.t('pages.vehicles.title.edit') }}
    </v-tab>
    <v-tab :to="installRoute" value="install">
      {{ i18n.global.t('pages.vehicleInstall.title') }}
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import i18n from '@/lang/i18n'

const route = useRoute()
const id = computed(() => route.params.id || null)
const formRoute = { name: 'VehicleForm', params: { id: id?.value } }
const installRoute = { name: 'VehicleInstall', params: { id: id?.value } }
const hasId = computed(() => !!id.value)

const activeTab = computed(() => {
  if (route.name === 'VehicleInstall') { 
    return 'install'
  }
  return 'form'
})

</script>